import React from 'react'
import AboutComponent from '../components/aboutComponent';


function About() {
  return (
    <>
      <AboutComponent/>
    </>
  )
}

export default About;